import { ComponentsAddressMapper } from "@omni/mappers/customer/address.mapper";
import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";
import { OrderCustomer } from "@omni/types/api/cart/bff/shared/orderCustomer.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import * as OrderUtils from "@omni/utils/order.utils";

import { CustomerAddress } from "@/components/Address/Address/address.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const OrderCustomerDetailsBlock = ({
    orderObject,
    customerObject
}: {
    orderObject: OrderDetail;
    customerObject: OrderCustomer;
}) => {
    const { t } = useGranite();

    return (
        <>
            {orderObject.billingAddress && (
                <div className="mb-4">
                    <h4>{t("orderOverview.label.billingAddress")}</h4>
                    {OrderUtils.isCustomerB2B(customerObject) && (
                        <p>
                            <div>{customerObject.companyName}</div>
                            <div>{customerObject.btwNumber}</div>
                        </p>
                    )}
                    <CustomerAddress
                        address={ComponentsAddressMapper.fromCloudCustomerOrder(
                            orderObject.billingAddress
                        )}
                        addressType={AddressType.Payment}
                    />
                </div>
            )}
            {customerObject && (
                <div className="mb-4">
                    <h4>{t("orderOverview.title.contact")}</h4>
                    <div>
                        {`${customerObject.firstName} ${customerObject.lastName}`}
                        <br />
                        {customerObject.email}
                        <br />
                        {customerObject.phone || ""}
                    </div>
                </div>
            )}
        </>
    );
};

export default OrderCustomerDetailsBlock;
